export const ClosingCompanySelectorTestIds = {
  COMPANY_SELECT: 'closing-company-selector.company-select',
};
